/**
 * Browser-side meter OCR fallback (Tesseract) used when the server has no
 * Gemini key. Mirrors Flutter's on-device ML Kit path by sending extracted_text.
 */

let workerPromise = null;

async function getWorker() {
  if (!workerPromise) {
    workerPromise = (async () => {
      const { createWorker } = await import("tesseract.js");
      const worker = await createWorker("eng");
      return worker;
    })().catch((err) => {
      workerPromise = null;
      throw err;
    });
  }
  return workerPromise;
}

/** Run OCR locally and return plain text, or null if unavailable. */
export async function extractTextFromMeterPhoto(file, { timeoutMs = 20000 } = {}) {
  if (!file) return null;

  const run = async () => {
    const worker = await getWorker();
    const { data } = await worker.recognize(file);
    const text = (data?.text || "").replace(/\s+/g, " ").trim();
    return text || null;
  };

  try {
    return await Promise.race([
      run(),
      new Promise((_, reject) => {
        setTimeout(() => reject(new Error("ocr_timeout")), timeoutMs);
      }),
    ]);
  } catch {
    return null;
  }
}
